import { lazy } from 'react';

// project-imports
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';
import { MenuCategory } from '../sections/menu/MenuCategory';
import { Navigate } from 'react-router-dom';
import { MenuItems } from '../sections/menu/MenuItems';
import AuthGuard from '../layout/Auth/AuthGuard';
import { MenuManage } from '../sections/menu/MenuManage';

// ==============================|| COMPONENT ROUTING ||============================== //

const MenuRoutes = {
  path: '/',
  element: <AuthGuard allowedRoles={['SUPER_ADMIN', 'ADMIN']}/>,
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'menu',
          children: [
            {
              // This makes /menu automatically open /menu/categories
              index: true, 
              element: <Navigate to="/menu/categories" replace /> 
            },
            {
              path: 'categories',
              element: <MenuCategory />
            },{
              path: 'foodItems',
              element: <MenuItems />
            },{
              path: 'manage-menu',
              element: <MenuManage/>
            }
          ]
        }
      ]
    }
  ]
};

export default MenuRoutes;
